export default {
  getFreeTrialEndPeriod: (state) => {
    return state.freeTrialEndPeriod;
  },
  getAssignee: (state) => {
    return state.assignee;
  },
};
